module.exports = __webpack_public_path__ + "files/bafed1b6df8024fa0722957ca4e99b75.png";